import * as React from 'react';
import { ReactElement } from 'react';
import { useCollectionPageFooter } from '../../state/CollectionPage';

export interface CollectionPageFooterProps {
  children?: React.ReactNode;
}

export type CollectionPageFooterElement = ReactElement<
  CollectionPageFooterProps,
  typeof CollectionPageFooter
>;

export function CollectionPageFooter(_props: CollectionPageFooterProps) {
  return null;
}

CollectionPageFooter.useCollectionPageFooter = useCollectionPageFooter;
CollectionPageFooter.displayName = 'CollectionPageFooter';
